import React, {Component, useState} from 'react';

import {
    Button,
    ComboBox,
    Dropdown,
    Accordion, AccordionItem, TextInput
} from "carbon-components-react";
import BasicDateTimePicker from "../DatePicker";
import "./index.scss";
import {Filter20} from "@carbon/icons-react";

export default class extends Component {

    state = {
        form: {
            report: "",
            type: "",
            typeDate: 'mm',
            date: "",
            localDate: false,
            localUnit: false,
        }
    };

    constructor(props) {
        super(props);

    }
    componentDidMount() {
        //     this.props.countFiles();
        //    this.props.fetchData({error: false,skip: 0});
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                report: this.props.businessId,
                type: this.props.typeDate,
                typeDate: this.props.typeDate,
                date: this.props.date,
            }
        }))
    }

    async getBase(base) {
    }

    async onSubmitForm() {
        this.props.onSubmitForm(this.state.form);
    }


    handleClick = (value) => {
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                'date': value
            }
        }))
    }


    render() {
        let {data, businessId, typeDate, date} = this.props;

        let bussiness_unit = [
            {id: "2236", text: "2236 - Unilever Brasil Ltda."},
            {id: "4313", text: "4313 - Cicanorte Ind. Com. S.A."},
            {id: "4664", text: "4664 - Unilever BR Gel. NE S.A."},
            {id: "5454", text: "5454 - Unilever BR Gelados Ltda."},
            {id: "9311", text: "9311 - Unilever BR Indust. Ltda."}
        ];
        let type = [{id: "yy", text: "Annual"}, {id: "mm", text: "Monthly"}];
        let buSelect = bussiness_unit.findIndex(x => x.id === businessId);
        let typeSelect = type.findIndex(x => x.id === typeDate);

        return (
            <div className="header-filter">
                <Accordion align='end' className="full-accordion">
                    <AccordionItem open="true" title="Filters (3)">

                        <div className="row">
                            <div className="col-4"><Dropdown
                                useTitleInItem={false}
                                id="report"
                                name="report"
                                label="Company"
                                titleText="Business Unit"
                                placeholder="Business"
                                invalid={false}
                                invalidText="Invalid Selection"
                                items={bussiness_unit}
                                initialSelectedItem={bussiness_unit[buSelect]}
                                selectedItem={bussiness_unit[this.state.form.report]}
                                itemToString={(item) => (item ? item.text : '')}
                                onChange={(evt) => {
                                    this.setState(prevState => ({
                                        form: {
                                            ...prevState.form,
                                            'report': evt.selectedItem.id,
                                            'localUnit': true
                                        }
                                    }));

                                }}
                            /></div>
                            <div className="col-3"><Dropdown
                                useTitleInItem={false}

                                id="type"
                                name="type"
                                label="Type"
                                titleText="Type"
                                placeholder="Annual"
                                invalid={false}
                                invalidText="Invalid Selection"
                                items={type}
                                initialSelectedItem={type[typeSelect]}
                                selectedItem={type[this.state.form.typeDate]}
                                itemToString={(item) => (item ? item.text : '')}
                                onChange={(evt) => {
                                    this.setState(prevState => ({
                                        form: {
                                            ...prevState.form,
                                            'type': evt.selectedItem.id,
                                            'typeDate': evt.selectedItem.id,
                                            'localDate': true,
                                        }
                                    }))
                                }}
                            /></div>
                            <div className="col-3">
                                <div className="date100">
                                    <BasicDateTimePicker handleClick={(data) => this.handleClick(data)}
                                                         date={this.state.form.localDate?this.state.form.date:date}
                                                         type={this.state.form.localDate?this.state.form.typeDate:typeDate}/>
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{paddingRight: "40px", paddingTop: "40px"}}>
                            <div className="col-12 row flex-row-reverse">
                                <Button style={{maxHeight: "48px", alignSelf: "flex-end", width: "150px"}}
                                        onClick={(e) => this.onSubmitForm()}
                                        kind='primary'>Apply</Button>
                            </div>
                        </div>
                    </AccordionItem>
                </Accordion>
            </div>
        );
    }
}
